import { createFileRoute } from '@tanstack/react-router';
import { TabelaLegalIcmsPage } from '@/components/tabela-legal-icms';

export const Route = createFileRoute('/_app/configuracoes/tabela-legal-icms')({
  component: TabelaLegalIcmsPage,
});
